export const TableThemes = {
  default: 'default',
  withBorder: 'withBorder', // there are profile icons in such tables, and you need to pass a smaller cell padding + border around
  withBorderWithoutProfileIcon: 'withBorderWithoutProfileIcon', // there is no profile icon in such tables, and you need to pass a larger cell padding + border around
  withoutProfileIcon: 'withoutProfileIcon', // there is no profile icon in such tables, and you need to pass a larger cell padding
  withBorderWhole: 'withBorderWhole', // in such tables, it is necessary that the border around the table touches the borders of the rows inside
  hiddenResult: 'hiddenResult',
} as const;

export type TableThemes = (typeof TableThemes)[keyof typeof TableThemes];

export interface TableThemeStyle {
  border: string | number;
  padding: string | number;
  tableTopMenuPadding: string | number;
  tableCellPadding: string | number;
  tableHeadCellPadding: string | number;
  tableFooterBorder: string;
}
